export const getRelativeCoordinates = (
  { clientX, clientY },
  { x, y },
) => ({
  x: clientX - x,
  y: clientY - y,
});
